module.exports = __webpack_public_path__ + "static/media/template.ac5a49c1.svg";